import { useAuth } from '@/contexts/auth-context'
import { useSignupStore } from '@/reducers'

/**
 * @temporary Resolves the user's email for the signup flow. Will be removed during v2 cleanup
 */
export const useSignupEmail = (): string => {
  const { user } = useAuth()
  const fromStore = useSignupStore.use.email()

  if (user?.email) return user.email
  if (fromStore) return fromStore
  return localStorage.getItem('email') ?? ''
}
